// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SellerLineMenu__link__count":"fj_a bhy_fm","SellerLineMenu__link--active":"fj_b bhy_ee"};